<div
  class="bg-black/20 h-full w-full absolute top-0 left-0 backdrop-blur-[2px] duration-500 z-1200"
  [class.hidden]="!isActive()"
  (click)="onToggleSidebar()"
></div>

<div
  class="fixed top-0 left-0 z-1201 flex flex-col h-full bg-blue-500 min-w-[200px] w-2/3 md:w-1/4 lg:w-1/5 xl:w-1/6 transition-transform duration-500 ease-in-out"
  [ngClass]="{
    'translate-x-0': isActive(),
    'translate-x-[-100%]': !isActive()
  }"
>
  <div class="p-4 shrink-0">
    <div class="bg-white p-2 rounded-xl shadow-xl overflow-hidden">
      <a routerLink="profile" (click)="onToggleSidebar()">
        <app-user-badge [name]="userFullName()" />
      </a>
      <p
        class="text-xl text-center text-gray-400 overflow-hidden text-ellipsis whitespace-nowrap my-4"
      >
        {{ userFullName() }}
      </p>
    </div>
  </div>
  <aside class="flex-1 min-h-0 overflow-y-auto flex flex-col p-4">
    <ul>
      @if(isAdmin()) {
      <li>
        <a
          (click)="onToggleSidebar()"
          routerLink="control-panel"
          routerLinkActive="bg-blue-600"
          [routerLinkActiveOptions]="{ exact: true }"
          class="relative flex mb-4 text-white font-semibold text-lg cursor-pointer bg-blue-400 hover:bg-blue-300 py-2 px-4 rounded-lg transition duration-300 ease-in-out"
        >
          <fa-icon [icon]="adminIcon" class="absolute left-4" />
          <span class="w-[85%] inline-block ml-8 overflow-hidden text-ellipsis whitespace-nowrap">Painel de Controle</span>
        </a>
      </li>

      } @else {
      <li>
        <a
          (click)="onToggleSidebar()"
          routerLink=""
          routerLinkActive="bg-blue-600"
          [routerLinkActiveOptions]="{ exact: true }"
          class="relative flex mb-4 text-white font-semibold text-lg cursor-pointer bg-blue-400 hover:bg-blue-300 py-2 px-4 rounded-lg transition duration-300 ease-in-out"
        >
          <fa-icon [icon]="homeIcon" class="absolute left-4" />
          <span class="w-[85%] inline-block ml-8 overflow-hidden text-ellipsis whitespace-nowrap">Home</span>
        </a>
      </li>
      <li>
        <a
          (click)="onToggleSidebar()"
          routerLink="profile"
          routerLinkActive="bg-blue-600"
          [routerLinkActiveOptions]="{ exact: true }"
          class="relative flex mb-4 text-white font-semibold text-lg cursor-pointer bg-blue-400 hover:bg-blue-300 py-2 px-4 rounded-lg transition duration-300 ease-in-out"
        >
          <fa-icon [icon]="profileIcon" class="absolute left-4" />
          <span class="w-[85%] inline-block ml-8 overflow-hidden text-ellipsis whitespace-nowrap">Perfil</span>
        </a>
      </li>
      }
    </ul>
    <div class="mt-auto">
      <hr class="border-blue-400 border-1 mb-4" />
      <button
        (click)="onLogout()"
        class="block relative rounded-lg py-2 text-white font-semibold text-lg cursor-pointer text-center w-full hover:bg-red-700 transition duration-300 ease-in-out"
      >
        <span>Sair</span>
        <fa-icon [icon]="exitIcon" class="absolute right-4" />
      </button>
    </div>
  </aside>
</div>
